export const environment = {
  env: 'development',
  production: false,
  api: 'https://dms-api.chapanakit.rtp-eservice.com',
  authApi: 'https://ums-api.chapanakit.rtp-eservice.com',
  s3: 'https://dms.chapanakit.rtp-eservice.com/mnt/dms-chapa',
  qrCodeApi: 'https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=',
  appVersion: "dms",
  USERDATA_KEY: "9a5f56ffc495",
  home: 'https://dms.chapanakit.rtp-eservice.com',
  portal: 'https://lpms.chapanakit.rtp-eservice.com',
};